"use client";
import { useEffect } from "react";
import Hotjar from "@hotjar/browser";
import { EXCLUDEDROUTES } from "@/app/constants/common";
import { publicEnvConfig } from "@/app/utils/config/config";
import { usePathname } from "@/i18n/navigation";

const UseHotjar = () => {
  const siteId = parseInt(publicEnvConfig.hotjarSiteId);
  const hotjarVersion = parseInt(publicEnvConfig.hotjarVersion);
  const pathname = usePathname();
  useEffect(() => {
    if (!EXCLUDEDROUTES.includes(pathname)) {
      Hotjar.init(siteId, hotjarVersion);
    }

    const handleRouteChange = (event: PopStateEvent) => {
      const newUrl = (event.currentTarget as Window).location.pathname;
      if (!EXCLUDEDROUTES.includes(newUrl)) {
        Hotjar.init(siteId, hotjarVersion);
      }
    };

    window.addEventListener("popstate", handleRouteChange);

    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, [siteId, hotjarVersion, pathname]);

  return <div className="hidden"></div>;
};

export default UseHotjar;
